module.exports = __webpack_public_path__ + "img/5-5.4991c0ff.png";